document.addEventListener('DOMContentLoaded', function () {
  const siteHeader = document.querySelector('.site-header');
  const toggles = document.querySelectorAll('.menu-toggle');
  const collapsable = document.getElementById('site-header-collapsable');
  const mainNav = collapsable?.querySelector('.header-main-nav');

  if (!siteHeader || toggles.length === 0 || !collapsable || !mainNav) return;

  const isDesktop = () => window.matchMedia('(min-width: 960px)').matches;

  const updateAccessibility = (expanded) => {
    toggles.forEach((btn) => {
      btn.setAttribute('aria-expanded', expanded.toString());
    });

    if (isDesktop()) {
      if (expanded) {
        mainNav.removeAttribute('inert');
      } else {
        mainNav.setAttribute('inert', '');
      }
      collapsable.removeAttribute('inert');
    } else {
      if (expanded) {
        collapsable.removeAttribute('inert');
      } else {
        collapsable.setAttribute('inert', '');
      }
      mainNav.removeAttribute('inert');
    }
  };

  const hideOnScroll = siteHeader.dataset.hideOnScrollDown === "1";
  const fixedHeader = siteHeader.classList.contains('fixed!');
  const regularColors = siteHeader.dataset.regularColors;
  const fixedColors = siteHeader.dataset.fixedColors;

  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateHeaderOnScroll() {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;
    const atTop = currentScrollY <= 0;

    if (fixedHeader && hideOnScroll) {
      if (scrollingDown && !atTop) {
        siteHeader.classList.add('translate-y-[-100%]');
        siteHeader.classList.remove('menu-open');
        if (regularColors) siteHeader.classList.remove('is-' + regularColors);
        if (fixedColors) siteHeader.classList.add('is-' + fixedColors);
        document.documentElement.style.setProperty('--fixed-header-height', '0rem');
      } else {
        siteHeader.classList.remove('translate-y-[-100%]');
        if (fixedColors) siteHeader.classList.remove('is-' + fixedColors);
        if (regularColors) siteHeader.classList.add('is-' + regularColors);
        document.documentElement.style.setProperty('--fixed-header-height', 'var(--header-height)');
      }
    } else if (fixedHeader) {
      document.documentElement.style.setProperty('--fixed-header-height', 'var(--header-height)');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderOnScroll);
      ticking = true;
    }
  }

  if (fixedHeader && hideOnScroll) {
    window.addEventListener('scroll', onScroll, { passive: true });
    updateHeaderOnScroll();
  } else if (fixedHeader) {
    document.documentElement.style.setProperty('--fixed-header-height', 'var(--header-height)');
  }

  const openMenu = () => {
    siteHeader.classList.add('menu-open');
    updateAccessibility(true);

    requestAnimationFrame(() => {
      const focusContainer = isDesktop()
        ? mainNav
        : collapsable;

      const firstFocusable = focusContainer.querySelector(
        'a[href], button:not([disabled], .menu-toggle), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (firstFocusable) {
        firstFocusable.focus({ preventScroll: true });
      }
    });
  };

  const closeMenu = () => {
    siteHeader.classList.remove('menu-open');
    updateAccessibility(false);
  };

  toggles.forEach((btn) => {
    const isCollapsableClose = btn.classList.contains('menu-toggle-collapsable');

    btn.addEventListener('click', () => {
      const isOpen = siteHeader.classList.contains('menu-open');

      if (isCollapsableClose || isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  });

  document.addEventListener('mousedown', (e) => {
    if (!isDesktop()) return;

    if (
      siteHeader.classList.contains('menu-open') &&
      !siteHeader.querySelector('.header-main-nav').contains(e.target) &&
      !e.target?.closest('.menu-toggle')
    ) {
      closeMenu();
    }
  });

  collapsable.addEventListener('keydown', (e) => {
    if (
      e.key === 'Escape' &&
      siteHeader.classList.contains('menu-open') &&
      !e.defaultPrevented
    ) {
      closeMenu();
    }
  });

  const mediaQuery = window.matchMedia('(min-width: 960px)');
  mediaQuery.addEventListener('change', () => {
    const isOpen = siteHeader.classList.contains('menu-open');
    updateAccessibility(isOpen);
  });

  updateAccessibility(siteHeader.classList.contains('menu-open'));
});
